/**
 * Diagnostic context
 * ------------------
 * Lightweight global store for "what was the user doing when the error
 * happened" — used by error reporters (window.onerror, React boundary,
 * leafletGuard) to enrich reports with the active screen and filters.
 *
 * Intentionally not a React context: must be readable from outside the
 * React tree (e.g. monkey-patched Leaflet constructors).
 */

export interface DiagnosticContext {
  screen?: string;
  filters?: Record<string, unknown>;
  extra?: Record<string, unknown>;
  updatedAt?: string;
}

let current: DiagnosticContext = {};

export function setDiagnosticContext(partial: DiagnosticContext): void {
  current = { ...current, ...partial, updatedAt: new Date().toISOString() };
}

export function clearDiagnosticContext(): void {
  current = {};
}

export function getDiagnosticContext(): DiagnosticContext {
  return current;
}